module.exports = __webpack_public_path__ + "assets/fonts/Novecentosanswide-Bold-webfont.woff2";